import { path } from "../paths";

const ROOTS_PAYABLES = "/payables";

export const PATH_PAYABLES = {
  root: ROOTS_PAYABLES,
  general: {
    unclassified: path(ROOTS_PAYABLES, "/unclassified"),
    purchaseInvoice: {
      root: path(ROOTS_PAYABLES, "/purchase-invoice"),
    },
    purchaseOrder: {
      root: path(ROOTS_PAYABLES, "/purchase-order"),
      general: {
        purchaseOrderDraft: path(`${ROOTS_PAYABLES}/purchase-order`, "/drafts"),
      },
    },
    purchaseDeliverynote: {
      root: path(ROOTS_PAYABLES, "/purchase-deliverynote"),
    },
  },
};
